export const BUILD_VERSION = '1783429416';
